import * as React from "react";
import {ProcessHeader, ProcessIndicator, ProcessIndicatorStep} from "../../Processes";

export interface MassiveActionsProcessHeaderProps {
    processHeaderTitle: string
    processIndicatorsTitles: string[]
}

export const MassiveActionsProcessHeader: React.FC<MassiveActionsProcessHeaderProps> = ({
                                                                                            processHeaderTitle,
                                                                                            processIndicatorsTitles
                                                                                        }) => {
    return <ProcessHeader processTitle={processHeaderTitle}>
        <ProcessIndicator>
            {processIndicatorsTitles?.map(
                (title, index) => <ProcessIndicatorStep key={index}>{title}</ProcessIndicatorStep>)}
        </ProcessIndicator>
    </ProcessHeader>
}

